<template>
  <v-container fluid>
    <v-card class="mx-auto" :loading="loading">
      <v-card-title>
        <h6>GESTIÓN</h6>
      </v-card-title>
      <v-card-text class="text--primary px-8">
        <ValidationObserver ref="form">
          <v-row>
            <v-col cols="12" sm="6" md="4">
              <ValidationProvider name="Estado" rules="required">
                <v-select
                  v-model="estado"
                  :items="estadoCasos"
                  item-text="estado"
                  item-value="estado"
                  label="Estado"
                  required
                  slot-scope="{ errors, valid }"
                  :error-messages="errors"
                  :success="valid"
                ></v-select>
              </ValidationProvider>
            </v-col>
            <v-col cols="12" sm="12" md="12">
              <ValidationProvider name="Descripcion" rules="required|min:35">
                <v-text-field
                  v-model="descripcion"
                  label="Descripción"
                  counter="35"
                  required
                  slot-scope="{ errors, valid }"
                  :error-messages="errors"
                  :success="valid"
                ></v-text-field>
              </ValidationProvider>
            </v-col>
            <v-col cols="12" sm="6" md="4">
              <v-file-input
                counter
                truncate-length="50"
                @change="datosDocumentos"
              ></v-file-input>
            </v-col>
          </v-row>
        </ValidationObserver>
        <v-dialog v-model="modalInmovilizacion" max-width="500">
          <v-card>
            <v-card-title class="text-h6">
              Inmovilización del vehículo
            </v-card-title>

            <v-card-text>
              Debes inmovilizar el vehículo. ¿Quieres aplicar esta acción?

              <v-radio-group v-model="vehiculoInmovilizadoSeleccion">
                <v-radio label="Sí" :value="true"></v-radio>
                <v-radio label="No" :value="false"></v-radio>
              </v-radio-group>

              <v-textarea
                v-if="vehiculoInmovilizadoSeleccion === true"
                v-model="resumen"
                label="Resumen del caso"
                hint="Este resumen queda guardado en el caso"
                persistent-hint
                rows="3"
                auto-grow
                required
              ></v-textarea>
            </v-card-text>

            <v-card-actions>
              <v-spacer></v-spacer>

              <v-btn text @click="modalInmovilizacion = false">
                Cancelar
              </v-btn>

              <v-btn color="primary" dark @click="confirmarGuardar">
                Confirmar
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-card-text>
      <v-card-actions class="pb-8 pl-8">
        <v-btn
          @click="abrirModalInmovilizacion"
          :loading="loading"
          color="workBtnBg"
          dark
        >
          <v-icon left>mdi-content-save-edit</v-icon>
          Guardar
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-container>
</template>

<script>
import { mapState, mapActions } from "vuex";
import { db, ref, storage, uploadBytes } from "../../firebase";
import moment from "moment-timezone";

export default {
  // eslint-disable-next-line vue/multi-word-component-names
  name: "Gestionar",
  data() {
    return {
      modalInmovilizacion: false,
      vehiculoInmovilizadoSeleccion: null,
      resumen: "",
      estado: "",
      descripcion: "",
      loading: false,
      estadoCasos: [],
      id: this.$route.params.id,
      file: "",
      datosCaso: null,
      nameArchivo: null,
      agentes: [
        "uidabogado",
        "uidinvestigador",
        "uidabogadocait",
        "uidcontactcenter",
        "uidperito",
      ],
      campo: "",
      consulta: "",
      cargoAgente: "",
      estadoAgente: "",
      identification: null,
      momento: "Cierre de caso",
    };
  },
  computed: {
    ...mapState(["logueado"]),
  },
  async mounted() {
    const resul = await db
      .collection("estadoscaso")
      .where("inactivo", "==", true)
      .orderBy("estado")
      .get();
    this.estadoCasos = resul.docs.map((doc) => ({
      id: doc.id,
      ...doc.data(),
    }));
    console.log(this.estadoCasos);
    const datos = await db.collection("casos").doc(this.id).get();
    this.datosCaso = {
      id: datos.id,
      ...datos.data(),
    };
  },
  methods: {
    ...mapActions("trazabilidad", ["trazabilidadEstadoUsuarios"]),

    async abrirModalInmovilizacion() {
      const validar = await this.$refs.form.validate();

      if (!validar) {
        return;
      }

      this.vehiculoInmovilizadoSeleccion = null;
      this.resumen = "";
      this.modalInmovilizacion = true;
    },
    async confirmarGuardar() {
      if (this.vehiculoInmovilizadoSeleccion === null) {
        this.$swal({
          icon: "warning",
          title: "Debes seleccionar una opción",
        });
        return;
      }

      if (this.vehiculoInmovilizadoSeleccion && !this.resumen.trim()) {
        this.$swal({
          icon: "warning",
          title: "Debes escribir un resumen del caso",
        });
        return;
      }

      this.modalInmovilizacion = false;
      this.loading = true;

      await this.save();
    },
    async save() {
      try {
        if (
          this.logueado.cargo != "Administrador" &&
          (this.datosCaso.estado == "Cancelado" ||
            this.datosCaso.estado == "Conciliado" ||
            this.datosCaso.estado == "CERRADO" ||
            this.datosCaso.estado == "No conciliado")
        ) {
          throw new Error(
            `El caso ha sido ${this.datosCaso.estado}, para realizar gestiones comuníquese con nuestro Administrador.`
          );
        }

        const validar = await this.$refs.form.validate();

        if (!validar) {
          this.loading = false;
          return false;
        }

        if (
          this.estado === "CERRADO" ||
          this.estado === "cerrado" ||
          this.estado === "Cancelado" ||
          this.estado === "Conciliado" ||
          this.estado === "No conciliado"
        ) {
          this.identification =
            this.logueado.identificacion ||
            JSON.parse(localStorage.getItem("logueado")).identificacion;
          await this.notificarSocket();
        }
        if (this.file) {
          console.log(this.file);
          this.nameArchivo = `${Date.now()}_${this.file.name}`;
          const storageRef = ref(storage, `DocGestion/${this.nameArchivo}`);
          await uploadBytes(storageRef, this.file);
        }
        await db.collection("trazabilidad").add({
          descripcion: this.descripcion,
          fechahora: new Date(),
          uidcaso: this.id,
          nameArchivo: this.file ? this.nameArchivo : "no",
          uidcreador: this.logueado.id,
        });
        const datosActualizar = {
          estado: this.estado,
          modificacion: new Date(),
          vehiculo_inmovilizado: this.vehiculoInmovilizadoSeleccion,
        };
        // El resumen solo se registra al inmovilizar el vehículo; si no, el
        // caso conserva el que ya tenía en lugar de la última gestión.
        if (this.vehiculoInmovilizadoSeleccion) {
          datosActualizar.descripcion = this.resumen.trim();
        }
        await db.collection("casos").doc(this.id).update(datosActualizar);
        this.datosCaso.estado = this.estado;
        this.datosCaso.vehiculo_inmovilizado =
          this.vehiculoInmovilizadoSeleccion;
        if (this.vehiculoInmovilizadoSeleccion) {
          this.datosCaso.descripcion = datosActualizar.descripcion;
        }
        if (
          this.estado == "Cancelado" ||
          this.estado == "Conciliado" ||
          this.estado == "No conciliado"
        ) {
          // TODO: falta por probar, liberar los agentes del caso.
          this.actualizarEstadoAgente();
        }
        this.$swal({
          icon: "success",
          title: this.vehiculoInmovilizadoSeleccion
            ? "Vehículo inmovilizado"
            : "Vehículo no inmovilizado",
          text: this.vehiculoInmovilizadoSeleccion
            ? "El vehículo fue inmovilizado correctamente."
            : "El vehículo fue marcado como no inmovilizado.",
        });
        this.estado = "";
        this.descripcion = "";
        this.resumen = "";
        this.file = "";
        this.loading = false;
      } catch (error) {
        this.handleError(error);
      }
    },
    async actualizarEstadoAgente() {
      // consultamos la cantidad de caso en los que esta asociado para determinar el estado
      for (const el of this.agentes) {
        console.log(el);
        if (el == "uidabogado") {
          if (!this.datosCaso.uidabogado) continue;
          this.campo = "uidabogado";
          this.consulta = this.datosCaso.uidabogado;
          this.cargoAgente = "Abogado";
        } else if (el == "uidabogadocait") {
          if (!this.datosCaso.uidabogadocait) continue;
          this.campo = "uidabogadocait";
          this.consulta = this.datosCaso.uidabogadocait;
          this.cargoAgente = "Abogado CAIT";
        } else if (el == "uidcontactcenter") {
          if (!this.datosCaso.uidcontactcenter) continue;
          this.campo = "uidcontactcenter";
          this.consulta = this.datosCaso.uidcontactcenter;
          this.cargoAgente = "Call Center";
        } else if (el == "uidinvestigador") {
          if (!this.datosCaso.uidinvestigador) continue;
          this.campo = "uidinvestigador";
          this.consulta = this.datosCaso.uidinvestigador;
          this.cargoAgente = "Investigador";
        } else if (el == "uidperito") {
          if (!this.datosCaso.uidperito) continue;
          this.campo = "uidperito";
          this.consulta = this.datosCaso.uidperito;
          this.cargoAgente = "Perito";
        }
        try {
          const result = await db
            .collection("casos")
            .where(this.campo, "==", this.consulta)
            .where("archivado", "==", false)
            .where("estado", "not-in", [
              "Cancelado",
              "Conciliado",
              "No conciliado",
              "CERRADO",
            ])
            .get();
          this.estadoAgente =
            result.size > 1 ? "Activo multiple" : "Activo ocupado";
          await db
            .collection("usuarios")
            .doc(this.consulta)
            .update({ disponibilidad: this.estadoAgente });
          console.log("se actualiza el estado del usuario", this.campo);
          this.trazabilidadEstadoUsuarios({
            descripcion: `El ${this.cargoAgente} ha sido liberado del caso # ${this.datosCaso.caso}`,
            estado: this.estadoAgente,
            uidcaso: this.id,
            cargo: this.cargoAgente,
            uidcreador: this.logueado.id,
            uidusuario: this.consulta,
          });
        } catch (error) {
          console.log(error);
          this.handleError(error);
        }
      }
    },
    async notificarSocket() {
      moment.tz.setDefault("America/Bogota");
      const caso = this.datosCaso.caso;
      const fechaActual = moment().format("YYYY-MM-DD HH:mm:ss");
      await db.collection("notificaciones").add({
        cedula: this.identification,
        caso,
        momento: this.momento,
        fechahora: fechaActual,
      });
    },
    datosDocumentos(file) {
      this.file = file;
      console.log(this.file);
    },
    handleError({ message }) {
      this.$swal({ icon: "error", title: "Oops...", text: message });
      this.loading = false;
    },
  },
};
</script>

<style src="./Caso.scss" lang="scss"></style>
